import {
  UserCircleIcon,
  ArrowRightStartOnRectangleIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../../contexts/AuthContext';

interface TopBarProps {
  onMenuToggle?: () => void;
}

export const TopBar = ({ onMenuToggle }: TopBarProps) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="fixed left-0 right-0 top-0 z-20 border-b border-gray-300 bg-white px-4 py-4 md:left-64 md:px-8">
      <div className="flex items-center justify-between md:justify-end">
        <button
          onClick={onMenuToggle}
          className="rounded-lg p-1 text-gray-600 hover:bg-gray-100 md:hidden"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>
        <div className="flex items-center gap-3">
          <span className="hidden text-s text-gray-700 sm:inline">
            {user?.email ?? 'User'}
          </span>
          <UserCircleIcon className="h-8 w-8 text-gray-600" />
          <button
            onClick={handleLogout}
            className="ml-2 flex items-center gap-1 rounded-button px-3 py-1.5 text-s text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-800"
            title="Sign out"
          >
            <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};
